import { Component, HostBinding, Input } from '@angular/core';
import { Association, AssociationKeys } from '@ag-common-lib/lib/models/utils/association.model';
import { Constants, EditorOptions, Messages } from '@ag-common-lib/lib/constants/validation.constants';
import {
  DATE_NOW,
  LOCAL_DATE_TIME_DATE_SERIALIZATION_FORMAT,
  MIN_DATE,
} from '@ag-common-lib/lib/constants/date.constants';
import { format, subYears } from 'date-fns';
import { ActiveLookup, Lookup } from '@ag-common-lib/lib/models/crm/lookup.model';

@Component({
  selector: 'ag-association-main-info-form',
  templateUrl: './association-main-info-form.component.html',
  styleUrls: ['./association-main-info-form.component.scss'],
})
export class AssociationMainInfoFormComponent {
  @HostBinding('class') className = 'association-main-info-form';
  @Input() associationFormData: Association;
  @Input() validationGroup: string;
  @Input() onGenderSelect: (item: Lookup) => void;
  @Input() onRelationshipTypeSelectionChanged: (item: ActiveLookup) => void;

  protected readonly AssociationKeys = AssociationKeys;
  readonly Messages = Messages;
  readonly totalPhoneDigits: number = Constants.TOTAL_PHONE_DIGITS;
  readonly phoneMask: string = Constants.PHONE_MASK;
  readonly maxDate: Date = subYears(DATE_NOW, 1);
  readonly minDate: Date = MIN_DATE;
  readonly dateEditorOptions = {
    ...EditorOptions.DATE,
    min: this.minDate,
    max: this.maxDate,
    dateSerializationFormat: LOCAL_DATE_TIME_DATE_SERIALIZATION_FORMAT,
    dateOutOfRangeMessage: `Please enter a date between ${format(this.minDate, Constants.DISPLAY_DATE_FORMAT)} and
      ${format(this.maxDate, Constants.DISPLAY_DATE_FORMAT)}`,
  };

  handleRelationshipTypeSelectionChanged = (item: ActiveLookup): void => this.onRelationshipTypeSelectionChanged(item);

  handleGenderSelect = (item: Lookup): void => this.onGenderSelect(item);
}
